if (!customElements.get("footer-campaign")) {
  class FooterCampaign extends HTMLElement {
    constructor() {
      super();
      this._ticking = false;
      this._onScroll = this._onScroll.bind(this);
    }

    connectedCallback() {
      this.wrap = this.previousElementSibling;
      this.content = this.querySelector("[data-campaign-content]");
      this.footer = this.closest(".footer");
      if (!this.wrap || !this.content || !this.footer) return;

      this.maxRadius = 48; // 3rem
      this.maxShadowOpacity = 0.6;
      this.parallaxDistance = 100;
      this._revealed = false;

      window.addEventListener("scroll", this._onScroll, { passive: true });
      window.addEventListener("resize", this._onScroll, { passive: true });
      this._onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener("scroll", this._onScroll);
      window.removeEventListener("resize", this._onScroll);
      if (this.wrap) {
        this.wrap.style.borderBottomLeftRadius = "";
        this.wrap.style.borderBottomRightRadius = "";
        this.wrap.style.boxShadow = "";
      }
      if (this.content) {
        this.content.style.transform = "";
        this.content.style.opacity = "";
      }
    }

    _onScroll() {
      if (this._ticking) return;
      this._ticking = true;
      requestAnimationFrame(() => {
        this._update();
        this._ticking = false;
      });
    }

    _update() {
      if (!this.wrap || !this.content) return;

      const viewportH = window.innerHeight;
      const campaignH = this.offsetHeight;
      const wrapBottom = this.wrap.getBoundingClientRect().bottom;
      const revealAmount = Math.max(0, viewportH - wrapBottom);
      const progress = Math.min(revealAmount / campaignH, 1);

      const revealed = progress > 0;
      if (revealed !== this._revealed) {
        this._revealed = revealed;
        const r = this.maxRadius + "px";

        // Wrap: rounded corners + shadow
        this.wrap.style.borderBottomLeftRadius = revealed ? r : "";
        this.wrap.style.borderBottomRightRadius = revealed ? r : "";
        this.wrap.style.boxShadow = revealed
          ? `0 20px 60px rgba(0,0,0,${this.maxShadowOpacity})`
          : "";
      }

      // Campaign content: parallax + fade in
      const ty = this.parallaxDistance * (1 - progress);
      this.content.style.transform = `translateY(${ty}px)`;
      this.content.style.opacity = Math.min(progress * 1.5, 1).toFixed(2);
    }
  }

  customElements.define("footer-campaign", FooterCampaign);
}
